import api from "@/utils/backend-api";
import {
   commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  items: [],
  pagination: {},
  loading: true,
  snackbar: false,
  customer: '',
};

const getters = {};

const actions = {
  getCustomerById ({ commit }, id) {
    commit("setLoading", { loading: true });
    if (id) {
      api.getData("blacklist?id=" + id).then(
        res => {
          const customer = res.data;
          commit("setCustomer", { customer });
          commit("setLoading", { loading: false });
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  quickSearch ({ commit }, { headers, qsFilter, pagination }) {
    api.getData("blacklist?qs=" + qsFilter).then(res => {
      commitPagination(commit, res.data);
    });
  },
};

const mutations = {
  setItems (state, customers) {
    state.items = customers;
  },
  setCustomer (state, customer) {
    state.customer = customer;
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setLoading (state, { loading }) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist.js